var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVorxocGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 726.86 602.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #39ff14;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M725.79,0l1.07,3.04c-19.43,37.8-35.96,77.05-54.65,115.2-2.97,6.07-15.14,32.35-18.86,35.09-1.64,1.2-3.41,1.63-5.43,1.56l-134.42-.04,71.16,147.13.77,4.12-141.28,295.39-160.97.97-3.5-1.5L0,0h436.07l74.93,150.83L585.93,0h139.86ZM508.5,154.85h-232.77l-100.85,213.31c.65.99,1.28,1.31,2.44,1.49,3.19.51,9.46.87,12.95,1.04,68.01,3.27,138.61-2.58,206.89,0l10.02-1.97,101.33-213.86Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVorxocGreen);
export default __webpack_public_path__ + "static/media/vorxocGreen.c899e5b5011a5a47ec85acb6ece87e78.svg";
export { ForwardRef as ReactComponent };